import buildItemComponent from "../../common/item-component-hoc"

import KeyIssueEditFormActionButtonsWidgetContainer from "./edit/KeyIssueEditFormActionButtonsWidgetContainer"
import KeyIssueEditItemContainer from "./edit/KeyIssueEditItemContainer"
import KeyIssueViewFormActionButtonsWidgetContainer from "./view/KeyIssueViewFormActionButtonsWidgetContainer"
import KeyIssueViewItemContainer from "./view/KeyIssueViewItemContainer"

export default buildItemComponent("keyIssues", {
    view: [
        KeyIssueViewFormActionButtonsWidgetContainer,
        KeyIssueViewItemContainer
    ],
    edit: [
        KeyIssueEditFormActionButtonsWidgetContainer,
        KeyIssueEditItemContainer
    ]
})
